<script lang="ts">
    import Router from "./Router.svelte";
</script>

<div>
    <Router>
        <slot />
    </Router>
</div>
